export const actions = {
  schedulePickup: 'schedulePickup',
  generateLabel: 'generateLabel',
  editAddress: 'editAddress',
  addTrackingNumber: 'addTrackingNumber',
  changeDeliveryMethod: 'changeDeliveryMethod',
}
